import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { AccessApiClient, accessApiRef } from './api';
import { rootRouteRef } from './routes';

export const adpAccessPlugin = createPlugin({
  id: 'access',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: accessApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new AccessApiClient(discoveryApi, fetchApi),
    }),
  ],
});

export const AccessPage = adpAccessPlugin.provide(
  createComponentExtension({
    name: 'AccessPage',
    component: {
      lazy: () => import('./components/AccessPage').then(m => m.AccessPage),
    },
  }),
);
